import { Panel } from 'src/modules/shared/components/molecules/panel';
import { ReportsDashboard } from 'src/modules/reports/components/reports-dashboard';

/**
 * Dedicated page for the widget-based reports dashboard.
 */
export const ReportsDashboardView: React.FC = () => {
  return (
    <div className="flex h-full flex-col bg-neutral-50">
      <Panel className="flex h-full flex-col overflow-hidden border-none bg-transparent shadow-none">
        <ReportsDashboard />
      </Panel>
    </div>
  );
};
